import { makeHttpRequest } from "@/shared";

export const deleteProduct = async (id) => {
    const response = (
        await makeHttpRequest({
            url: `/product/${id}`,
            method: "DELETE",
        })
    ).data;

    return response;
};
